import UserApi from 'api/rest/user'
import {
  WATCHLISTS_HREF,
  PRIVACY_AND_CONSENTS_HREF,
  SIGN_IN_DETAILS_HREF,
  MY_ACCOUNT_HREF,
  MY_DETAILS_HREF,
} from 'constants/global'
import { getOwnProfileUrl } from 'utils'

export const JOIN_BANNER_HEIGHT_MOBILE = 46
export const NAV_BAR_HEIGHT_MOBILE = 68
export const NAV_BAR_HEIGHT_TABLET = 76
export const NAV_BAR_HEIGHT_DESKTOP = 90
export const LANGUAGE_HEADER_HEIGHT_FALLBACK = 90
export const MOBILE_MENU_BREAKPOINT = 1024

export const SCROLL_THRESHOLD = 30
export const SCROLL_ACTIVE_THRESHOLD = 10

export const ACCOUNT_MENU_ID = 'account-menu-main'
export const MY_ACCOUNT_SUBMENU_KEY = 'My account'

export const PROFILE_PATH = getOwnProfileUrl()

export const ACCOUNT_MENU_ITEMS = [
  { id: 'acc-my-profile', name: 'My profile', path: PROFILE_PATH, isProfileItem: true },
  { id: 'acc-my-account', name: 'My account', path: MY_ACCOUNT_HREF },
  { id: 'acc-watchlists', name: 'Watchlists', path: WATCHLISTS_HREF },
  { id: 'acc-invite', name: 'Invite players', path: '/invite' },
  {
    id: 'acc-sign-out',
    name: 'Sign out',
    path: '#',
    action: () => {
      UserApi.signOut()
    },
  },
]

export const ACCOUNT_SUBMENU_MOBILE_ITEMS_KEYS = [
  { id: 'mob-acc-my-profile', nameKey: 'link.myProfile', path: PROFILE_PATH },
  {
    id: 'mob-acc-my-details',
    nameKey: 'myDetails',
    namespace: 'strMyAccount',
    path: MY_DETAILS_HREF,
  },
  { id: 'mob-acc-watchlists', nameKey: 'link.myWatchlists', path: WATCHLISTS_HREF },
  {
    id: 'mob-acc-privacy',
    nameKey: 'privacyAndConsents.title',
    namespace: 'strMyAccount',
    path: PRIVACY_AND_CONSENTS_HREF,
  },
  {
    id: 'mob-acc-signin',
    nameKey: 'signInDetails.title',
    namespace: 'strMyAccount',
    path: SIGN_IN_DETAILS_HREF,
  },
]
